module.exports = __webpack_public_path__ + "static/media/banner_pricing.ce9e290f.svg";